import bService from '@/api/base-api'
import { CONTRACT_MANAGER_URL } from '@/configs/service-url'

const list = async (hotelId) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/terms-conditions`
  const result = await bService.get(url)

  return result
}

const update = async (hotelId, data) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/terms-conditions`
  const result = await bService.put(url, data)

  return result
}

export default {
  list,
  update
}
